import React from 'react';

import { Link } from 'react-router-dom';

import { schemas } from '@recurrency/core-api-schema';
import { GetSalesInvoiceLinesReportGroupBy } from '@recurrency/core-api-schema/dist/reports/getSalesInvoiceLinesReport';

import { DEFAULT_NUM_ROWS_SHOWN, MiniTable } from 'components/MiniTable';
import { DEFAULT_PAGE_SIZE } from 'components/Table';

import { useCoreApi } from 'hooks/useApi';

import { optArrFromVal } from 'utils/array';
import { showAsyncModal } from 'utils/asyncModal';
import { formatUSD } from 'utils/formatting';
import { routes } from 'utils/routes';

import { SalesReportTable } from '../salesReport/SalesReportTable';
import { FilterByField } from '../salesReport/salesReportUtils';
import { getCurrentTimeZone } from '../salesReport/utils';
import { ViewAllModal } from './ViewAllModal';

export function TopCustomersPanelContext({
  itemId,
  companyId,
  locationId,
}: {
  itemId: string;
  companyId: string;
  locationId: string;
}) {
  const filter = {
    [FilterByField.Item]: optArrFromVal(itemId),
    [FilterByField.Location]: optArrFromVal(locationId),
    [FilterByField.Company]: optArrFromVal(companyId),
  };
  const { isLoading, data, error } = useCoreApi(schemas.reports.getSalesInvoiceLinesReport, {
    queryParams: {
      offset: 0,
      limit: DEFAULT_PAGE_SIZE,
      groupBy: GetSalesInvoiceLinesReportGroupBy.Customer,
      filter,
      yearToDate: true,
      requestTimezone: getCurrentTimeZone(),
    },
  });

  return (
    <>
      <MiniTable
        numRowsShown={DEFAULT_NUM_ROWS_SHOWN}
        data={data?.items}
        columns={[
          {
            render: (record) => (
              <>
                <Link to={routes.sales.customerDetails(record.foreignId)}>{record.foreignId}</Link>: {record.name}
              </>
            ),
            maxWidth: '130px',
          },
          {
            render: (record) => formatUSD(record.salesYtd),
            align: `right`,
          },
        ]}
        isLoading={isLoading}
        error={error}
        onMoreButtonClick={() => {
          showAsyncModal(ViewAllModal, {
            title: `Top Customers of Item #${itemId} at Location ${locationId}`,
            content: <SalesReportTable groupBy={GetSalesInvoiceLinesReportGroupBy.Customer} filter={filter} />,
          });
        }}
      />
    </>
  );
}
